export const parametrosKeys = {
  parametros: ['parametros'] as const,
  simulacao: (idExternoEmpreendimento: string) =>
    [...parametrosKeys.parametros, 'empreendimento', idExternoEmpreendimento, 'simulacao'] as const,
  proposta: () => [...parametrosKeys.parametros, 'proposta'] as const,
}
